module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section section-white content-padded view-flex view-flex-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "section-white view-warp"
  }, [_c('div', {
    attrs: {
      "id": "submitContent"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pages-view"
  }, _vm._l((_vm.pages), function(item, index) {
    return _c('div', {
      class: _vm.currentPage === index ? 'page active' : 'page',
      on: {
        "click": function($event) {
          return _vm.tabPage(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": "",
        "src": item.imgurl,
        "height": "569",
        "width": "320"
      }
    })])
  }), 0), _vm._v(" "), (_vm.currentPage === 0) ? _c('div', {
    staticClass: "template-view"
  }, [_c('div', {
    staticClass: "template",
    style: ('background:' + _vm.theme.bodyColor)
  }, [_c('div', {
    staticClass: "template-header",
    style: ('background:' + _vm.theme.bgColor + ' url(' + _vm.headerBg + ') no-repeat 0 4px; background-size: 100% auto;')
  }, [_c('div', {
    staticClass: "template-title",
    style: ('color:' + _vm.theme.fontColor)
  }, [_vm._v("标题")])]), _vm._v(" "), _c('el-carousel', {
    attrs: {
      "height": "160px",
      "autoplay": false
    }
  }, _vm._l((_vm.form.bannerPicList), function(item, index) {
    return (item.url) ? _c('el-carousel-item', {
      key: index,
      style: ('background: url(' + _vm.wximageurl + item.url + ') no-repeat center; background-size: cover')
    }) : _vm._e()
  }), 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "goods-list"
  }, [_c('div', {
    staticClass: "list-title"
  }, [_c('text', {
    staticClass: "title-txt"
  }, [_vm._v("精选推荐")])]), _vm._v(" "), _vm._l((_vm.form.hotGoods), function(item) {
    return _c('div', {
      staticClass: "goods view-flex view-flex-stretch"
    }, [_c('div', {
      staticClass: "goods-avatar",
      style: ('background:' + _vm.theme.bgColor + ' url(' + _vm.wximageurl + item.url + ') center / cover no-repeat;')
    }), _vm._v(" "), _c('div', {
      staticClass: "goods-caption view-flex-item view-flex view-flex-vertical view-flex-justify"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(item.item_name))]), _vm._v(" "), _c('div', {
      staticClass: "goods-key"
    }, [_vm._v(_vm._s(item.brief))]), _vm._v(" "), _c('div', {
      staticClass: "amount view-flex view-flex-bottom"
    }, [_c('div', {
      staticClass: "mark"
    }, [_c('text', {
      staticClass: "cur"
    }, [_vm._v("¥")]), _vm._v(" " + _vm._s(item.price / 100))])])])])
  })], 2), _vm._v(" "), _vm._m(3)], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentPage === 0) ? _c('div', {
    staticClass: "setting-view"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border with-bg"
  }, [_vm._v("轮播图配置")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_vm._l((_vm.form.bannerPicList), function(item, index) {
    return _c('div', {
      staticClass: "setting-item slider"
    }, [_c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.handleDelBanner(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt1"
    })]), _vm._v(" "), _c('div', [(item.url) ? _c('img', {
      staticClass: "banner-uploader",
      attrs: {
        "src": _vm.wximageurl + item.url
      },
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index, 'banner')
        }
      }
    }) : _c('div', {
      staticClass: "banner-uploader",
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index, 'banner')
        }
      }
    }, [_vm._m(4, true)])]), _vm._v(" "), _c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index, 'banner')
        }
      }
    }, [(item.item_id) ? _c('div', [_c('div', {
      staticClass: "thumb",
      style: ('background: url(' + _vm.wximageurl + item.url + ') no-repeat center; background-size: cover;')
    }), _vm._v(_vm._s(item.item_name) + "\n              ")]) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index, 'banner')
        }
      }
    }), _vm._v("绑定商品")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）")]), _vm._v(" "), _c('el-button', {
    staticClass: "el-icon-plus banner-button-uploader",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddBanner
    }
  }, [_vm._v("添加轮播图")])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border with-bg"
  }, [_vm._v("热门商品配置")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.form.hotGoods), function(item, index) {
    return _c('div', {
      staticClass: "setting-item hot"
    }, [_c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index, 'hotGoods')
        }
      }
    }, [(item.item_id) ? _c('div', [_c('div', {
      staticClass: "thumb",
      style: ('background: url(' + _vm.wximageurl + item.url + ') no-repeat center; background-size: cover;')
    }), _vm._v(_vm._s(item.item_name) + "\n              ")]) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link"
    }), _vm._v("绑定商品")])])])
  }), 0)]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentPage === 1) ? _c('div', {
    staticClass: "artical-setting-view"
  }, [(_vm.data.news) ? _c('div', {
    staticClass: "msgSender_content"
  }, [_c('div', {
    staticClass: "msg msg-item has-first-cover",
    class: _vm.data.news.content.news_item.length > 1 ? 'multi' : 'single'
  }, [_c('div', {
    staticClass: "msg-content"
  }, [_c('div', {
    staticClass: "msg-info"
  }, [_c('span', [_vm._v("更新于 " + _vm._s(_vm._f("datetime")(_vm.data.news.content.update_time)))])]), _vm._v(" "), _c('div', {
    staticClass: "sub-msg-item",
    class: _vm.data.news.content.news_item.length > 1 ? 'coverMsgItem' : ''
  }, [_c('h4', {
    staticClass: "msg-title"
  }, [_c('a', [_vm._v(_vm._s(_vm.data.news.content.news_item[0].title))])]), _vm._v(" "), _c('div', {
    staticClass: "msg-thumb-wrap",
    style: ({
      backgroundImage: 'url(' + _vm.wximageurl + _vm.data.news.content.news_item[0].thumb_url + ')'
    })
  }), _vm._v(" "), _c('a', {
    staticClass: "edit-mask preview-mask",
    attrs: {
      "href": _vm.data.news.content.news_item[0].url
    }
  }, [_c('div', {
    staticClass: "edit-mask-content"
  }, [_vm._v("\n                  预览文章\n                ")])]), _vm._v(" "), (_vm.data.news.content.news_item.length === 1) ? _c('p', {
    staticClass: "msg-desc"
  }, [_vm._v(_vm._s(_vm.data.news.content.news_item[0].digest))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.data.news.content.news_item), function(item, index) {
    return (index !== 0) ? _c('div', [(_vm.data.news.content.news_item.length > 1) ? _c('div', {
      staticClass: "article-msg-item has-cover clearfix"
    }, [_c('div', {
      staticClass: "msg-thumb-wrap",
      style: ({
        backgroundImage: 'url(' + _vm.wximageurl + item.thumb_url + ')'
      })
    }), _vm._v(" "), _c('h4', {
      staticClass: "msg-title"
    }, [_c('a', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('a', {
      staticClass: "edit-mask preview-mask",
      attrs: {
        "href": item.url
      }
    }, [_c('div', {
      staticClass: "edit-mask-content"
    }, [_vm._v("\n                    预览文章\n                  ")])])]) : _vm._e()]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "appmsg_preview_area"
  }, [_c('div', {
    staticClass: "appmsg_preview_container"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "appmsg_container_bd"
  }, [_c('div', {
    staticClass: "appmsg multi has_first_cover editing"
  }, [_c('div', {
    staticClass: "appmsg_content",
    attrs: {
      "id": "js_appmsg_preview"
    }
  }, [_vm._l((_vm.articals), function(item, index) {
    return [(index === 0) ? _c('div', {
      staticClass: "js_appmsg_item appmsg_item_wrp",
      class: _vm.id === index ? 'current' : '',
      on: {
        "click": function($event) {
          return _vm.handleClick(index)
        }
      }
    }, [_c('div', {
      staticClass: "first_appmsg_item",
      attrs: {
        "title": "第一篇图文"
      }
    }, [_c('div', {
      staticClass: "cover_appmsg_item"
    }, [_c('h4', {
      staticClass: "appmsg_title"
    }, [_c('a', {
      staticClass: "js_appmsg_title",
      attrs: {
        "href": "javascript:void(0);",
        "onclick": "return false;"
      }
    }, [(_vm.articals[0].title != '') ? [_vm._v("\n                                " + _vm._s(_vm.articals[0].title) + "\n                              ")] : [_vm._v("\n                                标题\n                              ")]], 2)]), _vm._v(" "), _c('div', {
      staticClass: "appmsg_thumb_wrp",
      style: ({
        backgroundImage: 'url(' + (item.thumb_url ? _vm.wximageurl + item.thumb_url : '') + ')'
      })
    }, [(!item.thumb_url) ? _c('div', {
      staticClass: "appmsg_thumb default"
    }, [_c('i', {
      staticClass: "icon_appmsg_thumb el-icon-picture"
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "appmsg_edit_mask"
    }, [_c('a', {
      staticClass: "icon20_common iconfont icon-arrow-down sort_down_white",
      attrs: {
        "onclick": "return false;",
        "title": "下移"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.sortdown(index)
        }
      }
    })])])]) : _c('div', {
      staticClass: "js_appmsg_item appmsg_item_wrp",
      class: _vm.id === index ? 'current' : '',
      on: {
        "click": function($event) {
          return _vm.handleClick(index)
        }
      }
    }, [_c('div', {
      staticClass: "appmsg_item has_cover"
    }, [_c('div', {
      staticClass: "appmsg_thumb_wrp",
      style: ({
        backgroundImage: 'url(' + (item.thumb_url ? _vm.wximageurl + item.thumb_url : '') + ')'
      })
    }, [(!item.thumb_url) ? _c('div', {
      staticClass: "appmsg_thumb default"
    }, [_c('i', {
      staticClass: "icon_appmsg_thumb_small el-icon-picture"
    })]) : _vm._e()]), _vm._v(" "), _c('h4', {
      staticClass: "appmsg_title js_appmsg_title"
    }, [(item.title != '') ? [_vm._v("\n                            " + _vm._s(item.title) + "\n                          ")] : [_vm._v("\n                            标题\n                          ")]], 2), _vm._v(" "), _c('div', {
      staticClass: "appmsg_edit_mask"
    }, [_c('a', {
      staticClass: "icon20_common sort_up_white iconfont icon-arrow-up",
      attrs: {
        "title": "上移"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.sortup(index)
        }
      }
    }), _vm._v(" "), (index !== (_vm.articals.length - 1)) ? _c('a', {
      staticClass: "icon20_common sort_down_white iconfont icon-arrow-down",
      attrs: {
        "title": "下移"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.sortdown(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "220",
        "trigger": "click"
      },
      model: {
        value: (item.popVisible),
        callback: function($$v) {
          _vm.$set(item, "popVisible", $$v)
        },
        expression: "item.popVisible"
      }
    }, [_c('p', {
      staticClass: "content-padded content-center",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("确定删除这篇文章？")]), _vm._v(" "), _c('div', {
      staticClass: "content-center"
    }, [_c('el-button', {
      on: {
        "click": function($event) {
          item.popVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.remove(index)
        }
      }
    }, [_vm._v("确定")])], 1), _vm._v(" "), (!_vm.isEditting) ? _c('a', {
      staticClass: "icon20_common del_media_white el-icon-delete",
      attrs: {
        "slot": "reference",
        "title": "删除"
      },
      slot: "reference"
    }) : _vm._e()])], 1)])])]
  })], 2)]), _vm._v(" "), (!_vm.isEditting) ? _c('div', {
    staticClass: "create_access_primary appmsg_add",
    attrs: {
      "title": "添加一篇图文"
    },
    on: {
      "click": _vm.addmsg
    }
  }, [_c('i', {
    staticClass: "icon35_common el-icon-plus"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "appmsg_input_area"
  }, [_vm._l((_vm.articals), function(item, index) {
    return (_vm.id === index) ? [_c('el-form', {
      ref: "item",
      refInFor: true,
      attrs: {
        "model": item,
        "label-position": "top",
        "label-width": "80px"
      }
    }, [_c('div', {
      staticClass: "content-padded"
    }, [_c('el-form-item', {
      staticStyle: {
        "height": "80px"
      },
      attrs: {
        "label": "标题"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入标题"
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    })], 1), _vm._v(" "), _c('el-form-item', [_c('vue-html5-editor', {
      ref: "editor",
      refInFor: true,
      attrs: {
        "content": item.viewcontent,
        "id": index,
        "height": 360
      },
      on: {
        "change": _vm.updateContent
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "content-padded appmsg_edit_highlight_area",
      staticStyle: {
        "height": "420px"
      }
    }, [_c('h3', {
      staticClass: "header-title"
    }, [_vm._v("发布样式编辑")]), _vm._v(" "), _c('div', {
      staticClass: "header_tips"
    }, [_vm._v("封面小图片 "), _c('span', {
      staticClass: "form-text-tip"
    }, [_vm._v("建议尺寸：200像素 * 200像素")])]), _vm._v(" "), _c('el-form-item', [_c('div', [_c('el-button', {
      on: {
        "click": _vm.addThumbPreview
      }
    }, [_vm._v("从图片库选择")])], 1), _vm._v(" "), (item.thumb_url) ? _c('div', {
      staticClass: "cover_preview",
      style: ({
        backgroundImage: 'url(' + (item.thumb_url ? _vm.wximageurl + item.thumb_url : '') + ')'
      })
    }) : _vm._e()])], 1)])] : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "appmsg_tpl_area"
  }, [_c('div', {
    staticClass: "appmsg_tpl_container"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "appmsg_container_bd"
  }, [_c('ul', {
    staticClass: "tpl_list",
    attrs: {
      "id": "js_media_list"
    }
  }, [_c('li', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("图片\n                ")])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  }), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.articalImgDialog,
      "sc-status": _vm.isGetArticalImage
    },
    on: {
      "chooseImg": _vm.pickArticalImg,
      "closeImgDialog": _vm.closeArticalImgDialog
    }
  })], 1)])])])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "select-goods-box",
    attrs: {
      "title": "选择商品",
      "visible": _vm.selectGoodsVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.selectGoodsVisible = $event
      }
    }
  }, [
    [_c('el-transfer', {
      attrs: {
        "titles": ['商品列表', '已选中'],
        "button-texts": ['移除选择', '添加选择'],
        "data": _vm.goodsList
      },
      on: {
        "change": _vm.handleSelectChange
      },
      model: {
        value: (_vm.selectGoods),
        callback: function($$v) {
          _vm.selectGoods = $$v
        },
        expression: "selectGoods"
      }
    }, [_c('div', {
      staticClass: "transfer-footer",
      attrs: {
        "slot": "left-footer"
      },
      slot: "left-footer"
    }, [(_vm.total_count > _vm.params.pageSize) ? _c('el-pagination', {
      attrs: {
        "small": "",
        "layout": "prev, pager, next",
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleSelectGoodsChange
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-footer with-border content-center",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.handleGoodsDialog
      }
    }, [_vm._v("确定")])], 1)]
  ], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-flex view-flex-middle view-flex-item"
  }, [_c('div', [_vm._v("主题：")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "theme-item"
  }, [_c('div', {
    staticStyle: {
      "background": "#f3b600"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#fff"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-flex view-flex-middle activity"
  }, [_c('img', {
    staticClass: "activity-icon",
    attrs: {
      "src": require("../../../../../static/img/gift.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "activity-title"
  }, [_vm._v("新手福利")]), _vm._v(" "), _c('div', [_vm._v("新入会员立即领取88元红包")])]), _vm._v(" "), _c('div', {
    staticClass: "activity-btn"
  }, [_vm._v("领取")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-flex view-flex-middle nav"
  }, [_c('div', {
    staticClass: "view-flex view-flex-vertical view-flex-middle view-flex-item nav-item"
  }, [_c('img', {
    staticClass: "nav-icon",
    attrs: {
      "src": require("../../../../../static/img/activity.png")
    }
  }), _vm._v("热门活动")]), _vm._v(" "), _c('div', {
    staticClass: "view-flex view-flex-vertical view-flex-middle view-flex-item nav-item"
  }, [_c('img', {
    staticClass: "nav-icon",
    attrs: {
      "src": require("../../../../../static/img/reseveration.png")
    }
  }), _vm._v("预约")]), _vm._v(" "), _c('div', {
    staticClass: "view-flex view-flex-vertical view-flex-middle view-flex-item nav-item"
  }, [_c('img', {
    staticClass: "nav-icon",
    attrs: {
      "src": require("../../../../../static/img/buy.png")
    }
  }), _vm._v("买单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "store"
  }, [_c('div', {
    staticClass: "store-more store-label"
  }, [_vm._v("全部门店")]), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('div', {
    staticClass: "store-name"
  }, [_vm._v("桂林路店")]), _vm._v(" "), _c('div', {
    staticClass: "store-desc"
  }, [_vm._v("上海市徐汇区桂林路396号2号楼")])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex view-flex-center store-contact"
  }, [_c('div', {
    staticClass: "store-contact-item"
  }, [_c('img', {
    staticClass: "store-icon",
    attrs: {
      "src": require("../../../../../static/img/store_location.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("1220 km")])]), _vm._v(" "), _c('div', {
    staticClass: "store-contact-item"
  }, [_c('img', {
    staticClass: "store-icon",
    attrs: {
      "src": require("../../../../../static/img/store_phone.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("咨询")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-center"
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _c('br'), _vm._v("\n                  上传图片\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appmsg_container_hd"
  }, [_c('h4', {
    staticClass: "appmsg_container_title"
  }, [_vm._v("小程序营销文章配置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appmsg_container_hd"
  }, [_c('h4', {
    staticClass: "appmsg_container_title"
  }, [_vm._v("多媒体")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b6f9d2ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6f9d2ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/template/store/universal.vue
// module id = 2913
// module chunks = 0